import React, { useState, useEffect } from "react";
import proscopeImage from "../../assest/image.png";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import { useLanguage } from "../LanguageContext";

const Header = () => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [activeButton, setActiveButton] = useState("Home");
  const location = useLocation();
  const { language, toggleLanguage } = useLanguage();

  const Menu = [
    {
      name: "Product",
      path: "/allproduct",
      subMenu: [
        { name: "Unique Products", path: "/productunique" },
        { name: "Hardware", path: "/producthardware" },
        { name: "Software", path: "/productsoftware" },
      ],
    },
    {
      name: "Enterprise Solution",
      path: "/solutions",
      subMenu: [
        { name: "Infrastructure", path: "/solutions#Infrastructure" },
        { name: "Opensource ERP", path: "/solutions#Opensource" },
        { name: "Security", path: "/solutions#Security" },
        { name: "Development", path: "/solutions#Development" },
      ],
    },
    {
      name: "Support Center",
      path: "/support",
      subMenu: [
        { name: "Proscope Ticket System (PTS)", path: "/support" },
        { name: "Maintenance Services", path: "/maintenance" },
      ],
    },
    {
      name: "Insights",
      path: "/allproduct",
      subMenu: [
        { name: "Case Study", path: "/casestudy" },
        { name: "Request a Whitepaper", path: "/home" },
        { name: "Blog (Coming soon)", path: "/home" },
      ],
    },
    { name: "IT Store", path: "/home" },
    {
      name: "About Us",
      path: "/aboutus",
      subMenu: [
        { name: "Who We Are", path: "/whoweare" },
        { name: "Vision & Mission", path: "/visionmission" },
        { name: "Industries We Serve", path: "/intusty" },
        { name: "Partners", path: "/partners" },
        { name: "Career", path: "/career" },
        { name: "Contact Us", path: "/contactus" },
      ],
    },
  ];

  const updateActiveButton = (path) => {
    const activeMenu = Menu.find((item) => {
      if (item.path.split("/")[1] === path) return true;
      if (item.subMenu) {
        return item.subMenu.some((subItem) => subItem.path.split("/")[1] === path);
      }
      return false;
    });
    setActiveButton(activeMenu ? activeMenu.name : "Home");
  };

  useEffect(() => {
    const path = location.pathname.split("/")[1];
    updateActiveButton(path);
  }, );

  useEffect(() => {
    const animationInterval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 2000);
    }, 5000);
    return () => clearInterval(animationInterval);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const handleSubMenuClick = () => {
    setIsMenuOpen(false);
    setIsSubMenuOpen(false);
  };

  return (
    <header className={`header ${isAnimating ? "animate" : ""}`}>
      <Link to="/home" className="logo">
          <img src={proscopeImage} alt="Proscope" className="logo-image" />
      </Link>
      <nav className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
        <ul>
          {Menu.map((item) => (
            <li
              key={item.name}
              className={item.className}
              onMouseEnter={() => setIsSubMenuOpen(item.name)}
              onMouseLeave={() => setIsSubMenuOpen(false)}
            >
              <Link
                to={item.path}
                className={activeButton === item.name ? "active" : ""}
                onClick={() => setActiveButton(item.name)}
              >
                {item.name}
              </Link>
              {isSubMenuOpen === item.name && item.subMenu && (
                <ul className="submenu">
                  {item.subMenu.map((subItem) => (
                    <li key={subItem.name}>
                      <Link to={subItem.path} onClick={handleSubMenuClick}>
                        {subItem.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
          <li>
            <button className="language-toggle" onClick={toggleLanguage}>
              {language === "en" ? "ภาษาไทย" : "English"}
            </button>
          </li>
        </ul>
      </nav>
      <button className="nav-toggle" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
    </header>
  );
};

export default Header;